import styled, { css } from 'styled-components';
import media from '../../constants/media';
import theme from '../../constants/theme';
import { Column, Columns } from '../base/grid';
import RichTextTitle from '../base/richTextTitle';
import IconButtonWithText from '../iconButtonWithText';

export const RichTextTitleStyled = styled(RichTextTitle)`
	text-align: center;
`;

export const IconButtonWithTextStyled = styled(IconButtonWithText)`
	margin-top: 8px;
	padding: 8px 6px;
	width: 100%;

	${media.tablet`
		padding: 24px;
	`};

	${media.desktopSmall`
		margin-top: 32px;
	`};
`;

export const InputWrapper = styled.div`
	width: 100%;
	margin-bottom: 16px;

	${media.tablet`
		max-width: 450px;
	`};
`;

export const InputRoot = styled.div`
	position: relative;
`;

export const Input = styled.input`
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 8px 8px 8px 32px;
	width: 100%;
	height: 72px;
	font-weight: ${theme.fonts.weight.regular};
	font-size: 18px;
	line-height: 1.5;
	color: ${theme.colorsV2.mainDark};
	border: 2px solid ${theme.colors.white};
	background: ${theme.colors.white};
	box-shadow: 0 4px 40px rgba(0, 0, 0, 0.08);
	border-radius: 16px;
	transition: border-color 100ms ease-in-out;

	${media.tablet`
		height: 80px;
		font-size: 20px;
		padding: 8px 77px 8px 32px;
	`}

	&::placeholder {
		color: ${theme.colorsV2.grey6};
	}

	&:focus,
	&:hover {
		border-color: ${theme.colorsV2.grey5};
	}
`;

export const ColumnsStyled = styled(Columns)`
	margin-inline: -4px;
	justify-content: center;

	${media.desktopSmall`
		margin-inline: -1.5rem;
	`};
`;

export const ColumnStyled = styled(Column)`
	display: flex;
	margin-bottom: 0;
	padding-inline: 4px;

	${media.desktopSmall`
		padding-inline: 1.5rem;
	`};
`;

export const SubmitButtonWrapper = styled.div`
	position: absolute;
	right: 8px;
	top: 50%;
	transform: translateY(-50%);
`;

export const ActionButtons = styled.div`
	width: 100%;
	margin-top: 92px;

	${media.desktopSmall`
		margin-top: 118px;
	`};
`;

export const TrackContainer = styled.div<{ displayAsCard: boolean }>`
	margin-top: 150px;
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	font-family: ${theme.fonts.Arimo};
	color: ${theme.colorsV2.mainDark};
	font-size: 18px;
	line-height: 1.4;
	letter-spacing: 0;

	${({ displayAsCard }) =>
		displayAsCard &&
		css`
			padding-block: 64px;

			${media.desktopSmall`
				border-radius: 16px;
				box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.08);
				padding: 96px 48px;
			`};
		`}

	${InputWrapper} {
		margin-top: ${({ displayAsCard }) => (displayAsCard ? '32' : '65')}px;
	}
`;
